import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RequestManagementService } from 'src/service/request-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { InteractionType, KeyValues10, LocalService, Status } from '../../../service/local.service';
import { ProductManagementService } from '../../../service/product-management.service';

@Component({
  selector: 'app-product-logs',
  templateUrl: './product-logs.component.html',
  styleUrls: ['./product-logs.component.scss']
})
export class ProductLogsComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["product_log", "table"]; ctryCode: string = '';
  businessId: string = ''; interactionType = 0; userId: string = '';
  items: KeyValues10[]; maxBodyHeight = 0;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private productManagementService: ProductManagementService, private route: ActivatedRoute, private requestManagementService: RequestManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.userId = routeParams.userId;
        this.ctryCode = routeParams.ctryCode;
        this.onLoad();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.productManagementService.getProductLogs(this.businessId, this.ctryCode).subscribe(result => {
      this.items = result;
    });
  }

  onAction(index, key = '') {
    switch (index) {
      case 1: {
        this.requestManagementService.retryJob(key).subscribe(result => {
          if (result.status == Status.Success) {
            this.onLoad();
          }
          this.localService.showInformationByStatus(result.status);
        });
      } break;
    }
  }
}
